import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ModelsSelectService } from '../../services';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-models-select',
  templateUrl: './models-select.component.html',
  styleUrls: ['./models-select.component.scss']
})
export class ModelsSelectComponent implements OnInit {
  @Output() selectedBrand = new EventEmitter();
  @Output() selectedModel = new EventEmitter();

  @Input() brandSelected = "";
  @Input() modelSelected = "";

  @ViewChild('viewBrandSelected', { static: true }) viewBrandSelected: ElementRef;

  brands;
  models;

  modal = false;

  modalBrand = false;
  modalModel = false;

  newBrand = { "id": null, "name": "" };
  newModel = { "id": null, "name": "" };

  constructor(
    private modelsSelectService: ModelsSelectService,
    private loadingBarService: LoadingBarService
  ) { }

  ngOnInit() {
    this.listBrands();
  }

  listBrands() {
    this.brands = [];
    this.models = [];

    this.modelsSelectService.listBrands().subscribe((response) => {
      this.brands = response['data'];

      setTimeout(() => {
        this.populateModels(this.viewBrandSelected.nativeElement.selectedIndex);
      }, 100);
    });
  }

  populateModels(index) {
    if (index) {
      this.models = this.brands[index-1].modelos;
    } else {
      this.models = [];
    }
  }

  selectBrand(val) {
    if (val) {
      this.selectedBrand.emit(JSON.parse(val));
    }
  }

  selectModel(val) {
    if (val) {
      this.selectedModel.emit(JSON.parse(val));
    }
  }

  convertToJson(id, name) {
    return `{"id":${id},"name":"${name}"}`;
  }

  jsonParse(val) {
    if (val) {
      return JSON.parse(val);
    } else {
      return "";
    }
  }

  editNewBrand(id, name) {
    if (id && name) {
      this.newBrand.id = id;
      this.newBrand.name = name;
    } else {
      this.newBrand.id = null;
      this.newBrand.name = "";
    }
  }

  editNewModel(id, name) {
    if (id && name) {
      this.newModel.id = id;
      this.newModel.name = name;
    } else {
      this.newModel.id = null;
      this.newModel.name = "";
    }
  }

  openModal(type) {
    this.modal = true;

    if(type == "brand") {
      this.modalBrand = true;

      this.resetModal();
    }

    if(type == "model") {
      this.modalModel = true;
    }
  }

  resetModal() {

    this.newBrand = { "id": null, "name": "" };
    this.newModel = { "id": null, "name": "" };
  }

  closeModal() {
    this.modal = false;

    this.modalBrand = false;
    this.modalModel = false;

    this.resetModal();
  }

  addBrandModel() {
    this.loadingBarService.start();

    let raw = {
      "cdProdutoMarca": this.newBrand.id,
      "dsProdutoMarca": `${this.newBrand.name}`,
      "modelos": [
        {
          "cdProdutoModelo": this.newModel.id,
          "dsProdutoModelo": `${this.newModel.name}`
        }
      ]
    };

    this.modelsSelectService.addBrands(raw).subscribe((response) => {
      this.loadingBarService.complete();

      this.listBrands();

      this.closeModal();

      Swal({
        type: "success",
        title: "Marca/modelo cadastrado.",
        text: "Essa marca/modelo, aparecerá na listagem.",
        confirmButtonText: "Ok, entendi!",
        confirmButtonClass: "sweet-button",
        buttonsStyling: false
      });
    });
  }

}
